import { render, staticRenderFns } from "./ContentHome.vue?vue&type=template&id=4c5d800d&scoped=true"
import script from "./ContentHome.vue?vue&type=script&lang=js"
export * from "./ContentHome.vue?vue&type=script&lang=js"
import style0 from "./ContentHome.vue?vue&type=style&index=0&id=4c5d800d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d800d",
  null
  
)

export default component.exports